var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScreenAngleSCurve(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icon-screens-arrow-angle-w-s-curve"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-screens-arrow-angle-w-s-curve",
    clipPath: "url(#clip-Icon-screens-arrow-angle-w-s-curve)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-screens-arrow-angle_w_s_curve",
    "data-name": "Icon-screens-arrow-angle w/s curve",
    transform: "translate(3 5.404)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_235",
    "data-name": "Line 235",
    x1: 6.655,
    y2: 6.596,
    transform: "translate(14.655 1)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_236",
    "data-name": "Line 236",
    y1: 8.809,
    transform: "translate(0 -0.404)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M-10035.435,10629.5s4.477,10.085,8.322,4.962,5.479-5.169,9.512-1.085",
    transform: "translate(10035.5 -10629.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenAngleSCurve);
export default __webpack_public_path__ + "static/media/screen-angle-s-curve.3fcfcaa90421fc5ba5364a8c263cdaf1.svg";
export { ForwardRef as ReactComponent };